/* unplugin-vue-components disabled */import script from "./up-token.vue?vue&type=script&lang=ts&setup=true"
export * from "./up-token.vue?vue&type=script&lang=ts&setup=true"

import "./up-token.vue?vue&type=style&index=0&id=57e8508f&lang=scss"

const __exports__ = script;

export default __exports__